import { DISPLAY_MESSAGE_STATUS_FEATURE_START_DATE } from '../constants/general';
import {
  SERVICE_CASE_MANAGEMENT,
  SERVICE_CALL_FORWARDING,
  QUEUES,
  FEATURE_FLAG_EVENT_MESSAGE_REDESIGN,
} from '../constants/permissions';
import { useCheckPermissions } from './common';

export const isMultiPartyEnabled = (userPermissions) =>
  userPermissions.includes('MULTI_PARTY_TEXTING');

export const useDisplayFailedMessageStatus = (
  messageStatus,
  messageCreatedAt,
  isMessageStatusEnabled,
  retryAttempted,
  isMultiPartyChat,
) => {
  const messageCreatedAtDate = new Date(messageCreatedAt);
  return (
    isMessageStatusEnabled &&
    messageStatus &&
    ['failed', 'undelivered'].includes(messageStatus.toLowerCase()) &&
    !retryAttempted &&
    !isMultiPartyChat &&
    Date.parse(messageCreatedAtDate) >
      Date.parse(DISPLAY_MESSAGE_STATUS_FEATURE_START_DATE)
  );
};

export const useIsServiceProductEnabled = () =>
  useCheckPermissions([SERVICE_CASE_MANAGEMENT]);

export const useIsServiceCallForwardingEnabled = () =>
  useCheckPermissions([SERVICE_CALL_FORWARDING]);

export const hasPermissionChanged = (
  prevPermissions,
  permissions,
  featureFlag,
) =>
  prevPermissions !== null &&
  prevPermissions?.includes(featureFlag) !== permissions?.includes(featureFlag);

export const useIsQueuesEnabled = () => useCheckPermissions([QUEUES]);

export const useIsEventMessageRedesignEnabled = () =>
  useCheckPermissions([FEATURE_FLAG_EVENT_MESSAGE_REDESIGN]);

// SSM-based feature flag: In production, webpack DefinePlugin injects a boolean directly.
// In tests, process.env values are strings. This handles both cases.
export const isSecondaryOperatorUIEnabled = () => {
  const flagValue = process.env.FEATURE_FLAG_SECONDARY_OPERATOR_UI;
  return flagValue === true || flagValue === 'true';
};

export const isBulkUserUploadWorkerEnabled = () => {
  const flagValue = process.env.FEATURE_FLAG_BULK_USER_UPLOAD_WORKER;
  return flagValue === true || flagValue === 'true';
};

export const isContactPrefixEnabled = () => {
  const flagValue = process.env.FEATURE_FLAG_CONTACT_PREFIX;
  return flagValue === true || flagValue === 'true';
};

export const isUnaddressedEnabled = () => {
  const flagValue = process.env.FEATURE_FLAG_UNADDRESSED_ENABLED;
  return flagValue === true || flagValue === 'true';
};

export const isIgnoreOptInYesUnaddressedFlagOn = () => {
  const flagValue = process.env.FEATURE_FLAG_IGNORE_OPT_IN_YES_UNADDRESSED;
  return flagValue === true || flagValue === 'true';
};

export const isDetailsNavFrameworkEnabled = () => {
  const flagValue = process.env.FEATURE_FLAG_DETAILS_NAV_FRAMEWORK;
  return flagValue === true || flagValue === 'true';
};
